import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NotificationService } from "../../services/Notification.service";
import { AuthV2Service } from "../../services/authV2Service";
import { useAuthV2ReCaptcha } from "../../hooks/useAuthV2ReCaptcha";
import { useStoreAuthV2 } from "../../store/AuthV2Store";
import { useStorePageManager } from "../../store/PageManage";
import InputPhoneNumber from "../cells/InputPhoneNumber";

export const AuthV2SocialPhonePanel = ({
  currentState = 1,
  panelState,
  setPanelState,
}) => {
  const { t } = useTranslation();
  const { executeSocialValidatePhone } = useAuthV2ReCaptcha();
  const { prospectId, identifier, setPendingOtpPhone, setOtpState, setCurrentStep, setTestOtpCode } =
    useStoreAuthV2();

  const [loading, setLoading] = useState(false);
  const [phoneData, setPhoneData] = useState({
    telephone: "",
    indicatif: "",
  });
  const [stateTelephone, setStateTelephone] = useState({
    focus: false,
    error: false,
    good: false,
  });
  const [curentCountrySelected, setCurentCountrySelected] = useState();

  useEffect(() => {
    if (phoneData.telephone.length > 2) {
      if (phoneData.telephone.length >= 8) {
        setStateTelephone({ ...stateTelephone, error: false, good: true });
      } else {
        setStateTelephone({ ...stateTelephone, error: true, good: false });
      }
    } else {
      setStateTelephone({ ...stateTelephone, error: false, good: false });
    }
  }, [phoneData.telephone]);

  const handleUptadeTelephone = (e) => {
    let newTelephone = e.target.value.replace(/[^0-9]/g, "");
    setPhoneData({ ...phoneData, telephone: newTelephone });
    e.target.value = newTelephone;
  };

  const getPhoneNumber = () => {
    let tel = phoneData.indicatif + phoneData.telephone;
    if (tel[0] !== "+") tel = "+" + tel;
    return tel;
  };

  const isFormValid = () => {
    return stateTelephone.good && curentCountrySelected;
  };

  const handleValidate = async () => {
    if (!isFormValid() || loading) return;

    setLoading(true);
    try {
      const captchaToken = await executeSocialValidatePhone();
      const phoneNumber = getPhoneNumber();

      const response = await AuthV2Service.socialValidatePhone({
        prospectId,
        phoneNumber,
        captchaToken,
      });

      setPendingOtpPhone(phoneNumber);
      setTestOtpCode(response.data.otpCode);
      setOtpState(true, new Date(Date.now() + 60 * 1000), null);
      setCurrentStep("otp");

      NotificationService.addToQueue(
        0,
        t("modals.connexionPanel.authV2.otpSentPhone"),
      );

      setPanelState({
        ...panelState,
        authV2SocialPhone: 0,
        authV2Otp: 1,
      });
    } catch (error) {
      const errorMsg = error.message || "";

      if (errorMsg.includes("déjà") || errorMsg.includes("already")) {
        NotificationService.addToQueue(
          2,
          t("modals.connexionPanel.authV2.phoneAlreadyUsed"),
        );
      } else {
        NotificationService.addToQueue(
          2,
          errorMsg || t("modals.connexionPanel.authV2.genericError"),
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setPanelState({
      ...panelState,
      authV2SocialPhone: 2,
      authV2Entry: 1,
    });
  };

  const handleContactSupport = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=+2250556094636&text=Bonjour%2C%20j%27ai%20besoin%20d%27aide%20pour%20mon%20inscription",
      "_blank",
    );
  };

  return (
    <div
      className={`contains inscription-part ${
        currentState === 0
          ? "go-left-side"
          : currentState === 1
            ? "come-center"
            : "go-right-side"
      } | flcolm`}
    >
      <button className="back-btn | btn" onClick={handleBack}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="var(--gray-900)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <span className="auth-v2-panel-title">
        {t("modals.connexionPanel.authV2.socialPhoneTitle")}
      </span>
      <label className="auth-v2-welcome">
        {t("modals.connexionPanel.authV2.socialPhoneWelcome")}
      </label>
      <p className="auth-v2-subtitle">
        {t("modals.connexionPanel.authV2.socialPhoneHint", {
          email: identifier,
        })}
      </p>

      <div className="input-field | flcolm">
        <InputPhoneNumber
          dataInscription={phoneData}
          setDataInscription={setPhoneData}
          setStateTelephone={setStateTelephone}
          stateTelephone={stateTelephone}
          handleUptadeTelephone={handleUptadeTelephone}
          curentCountrySelected={curentCountrySelected}
          setCurentCountrySelected={setCurentCountrySelected}
          setindicatif={(val) =>
            setPhoneData((prev) => ({ ...prev, indicatif: val }))
          }
          indicatif={phoneData.indicatif}
        />
      </div>

      <div className="auth-v2-footer | flrow allcenter">
        <button
          onClick={handleContactSupport}
          className="btn-outline | btn flex"
        >
          {t("modals.connexionPanel.authV2.contactSupport")}
        </button>
        <button
          onClick={handleValidate}
          className="next-btn | btn flex"
          disabled={!isFormValid() || loading}
        >
          {loading
            ? t("modals.connexionPanel.authV2.loading")
            : t("modals.connexionPanel.authV2.validateBtn")}
        </button>
      </div>
    </div>
  );
};
